import { createI18n } from "vue-i18n"

import en from "@/i18n/locales/en.json"
import de from "@/i18n/locales/de.json"
import ja from "@/i18n/locales/ja.json"
import zh from "@/i18n/locales/zh.json"
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "@/store/useLanguageStore"

const i18n = createI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  legacy: false,
  availableLocales: SUPPORTED_LOCALES,
  messages: {
    en,
    de,
    zh,
    ja
  }
})

export default i18n
